export const imageData = {
  body: { title: "Body", total: 17, link: "./character/body" },
  clothes1: {
    title: "Clothes-Layer1",
    total: 5,
    link: "./character/clothes/layer_1",
  },
  clothes2: {
    title: "Clothes-Layer2",
    total: 5,
    link: "./character/clothes/layer_2",
  },
  clothes3: {
    title: "Clothes-Layer3",
    total: 9,
    link: "./character/clothes/layer_3",
  },
  eyebrows: { title: "Eyebrows", total: 15, link: "./character/eyebrows" },
  eyes: { title: "Eyes", total: 24, link: "./character/eyes" },
  facialHair: {
    title: "Facial Hair",
    total: 18,
    link: "./character/facial_hair",
  },
  hair: { title: "Hair", total: 73, link: "./character/hair" },
  mouths: { title: "Mouths", total: 24, link: "./character/mouths" },
  noses: { title: "Nose", total: 1, link: "./character/noses" },
  earrings: {
    title: "Earrings",
    total: 32,
    link: "./character/accessories/earrings",
  },
  glasses: {
    title: "Glasses",
    total: 17,
    link: "./character/accessories/glasses",
  },
  hats: {
    title: "Hats",
    total: 28,
    link: "./character/accessories/hats",
  },
  neckwear: {
    title: "Neckwear",
    total: 18,
    link: "./character/accessories/neckwear",
  },
};
